module.exports = __webpack_public_path__ + "3dee9ae8f64eb51ea6ea172747944149.svg";